<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-7">
        <lib-page-header page-title="AUDITORIA DO SISTEMA"
          page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/portfolio.png">
        </lib-page-header>
      </div>
      <div class="col-md-5">
        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <a (click)="exportarXLSX()" class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/file_xls.png" alt="xls" title="gerar xls" height="20" width="20">
        </a>
        <a (click)="imprimirPDF()" class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/file_pdf.png" alt="cvs" title="Gerar pdf" height="20" width="20">
        </a>
        <select #operacaoS (change)="onChangeOperation($event, operacaoS.value)" name="selecOperacao"
          style="border: none !important" style="font-weight: bold;  width: 200px;"
          class="custom-select custom-select-sm float-right mr-3">
          <option [selected]="item.id === operacao" [class]="item.class" [value]="item.id" *ngFor="let item of listOperacoes">
            {{item.nome}}
          </option>
        </select>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="col-md-3">
        <p-autoComplete [(ngModel)]="alvo" [suggestions]="listAlvosAutoC" [dropdown]="true" [style]="{'width':'100%'}"
          [inputStyle]="{'width':'100%'}" (completeMethod)="onChangeAlvo($event)" [forceSelection]="true"></p-autoComplete>
      </div>
      <div class="form-group col-md-2">
        <p-calendar id="data1" [(ngModel)]="data1" inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy"
          [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </div>
      <div class="form-group col-md-2">
        <p-calendar id="data2" [(ngModel)]="data2" inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy"
          [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </div>
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <table class="table table-eddy">
          <thead>
            <tr>
              <th scope="col">Alvo</th>
              <th scope="col">Usuário</th>
              <th scope="col" class="text-center">Data Cadastro</th>
              <th scope="col" class="text-center">Operação</th>
              <th scope="col" style="width: 90px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lista">
              <th scope="row">{{item.alvo}}</th>
              <td>{{item.usuario?.nome ? item.usuario.nome : usuarioNull}}</td>
              <td class="text-center">{{item.data_cadastro | date:'dd/MM/yyyy':'GMT'}}</td>
              <td class="text-center">
                <span *ngIf="item.operacao === 'R'" class="badge badge-danger">REMOÇÃO</span>
                <span *ngIf="item.operacao === 'A'" class="badge badge-warning">ALTERAÇÃO</span>
                <span *ngIf="item.operacao === 'I'" class="badge badge-primary">INSERÇÃO</span>
              </td>
              <td class="text-right">
                <button  [routerLink]="['/auditoria', item.id, 'visualizar']" routerLinkActive="router-link-active"
                  class="btn btn-sm btn-outline-secondary mr-2">
                  <img src="assets/img/global/zoom.png" alt="editar" height="18" width="18">
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-12">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
  </div>
</div>